import { defineComponent, h } from 'vue'

import t, { initTranslations } from '@/javascript/lib/i18next'

export default defineComponent({
	name: 'Translation',

	beforeMount() {
		initTranslations()
	},

	props: {
		args: {
			type: Object,
			default: () => ({}),
		},
		dataTest: {
			type: String,
			default: '',
		},
		tag: {
			type: String,
			default: 'p',
		},
		tKey: { // short for translationKey. key is reserved, we can't use it.
			type: String,
			required: true,
		},
	},

	render() {
		const translation = t(this.tKey, this.args)
		const extraProps = {} as Record<string, any>

		if (this.dataTest)
			extraProps['data-test'] = this.dataTest

		return h(
			this.tag,
			{
				...this.$attrs,
				...extraProps,
				innerHTML: translation,
			}
		)
	},
})
